import { RingProgress, Text } from '@mantine/core';

import type { RingStatViewProps } from './RingStat.types';

export function RingStatView({ value, color = 'blue', size = 120, thickness = 10, label }: RingStatViewProps) {
  return (
    <RingProgress
      size={size}
      thickness={thickness}
      roundCaps
      sections={[{ value: Math.min(value, 100), color }]}
      label={
        <Text ta="center" size="sm" fw={700}>
          {label ?? `${Math.round(value)}%`}
        </Text>
      }
    />
  );
}
